import { Alert, type AlertProps } from 'antd';
import styled from 'styled-components';
import { getAlertStyleByType } from '../utils/getAlertStyleByType';

export const StyledAlert = styled(Alert)<AlertProps>`
  border-radius: 8px;
  padding: 12px;
  border: none;
  align-items: flex-start;

  .ant-alert-icon {
    margin-inline-end: 8px;
    font-size: 16px;
  }

  ${({ type }) => getAlertStyleByType(type)}
`;
